<template>
  <div>
    <!-- DEV -->
      <!-- <h1>Inventory Top Sales Table</h1> -->
    <!--  -->
    <!-- <q-pull-to-refresh
      @refresh="store.getData"
      :no-mouse="false"
      color="orange-2"
      bg-color="black"
      icon="autorenew"
    > -->
    
    <div data-dev-group="title_header" >
      <h6>Monthly Charges</h6>
      <br><br>
      <input type="date" v-model="store.month">
      <button @click="store.getData()">Get Data</button>
    </div>

    <div data-dev-group="data-meta" >
      
      <div v-if="store.isLoading === false && store[store.dataKey] && store[store.dataKey].length === 0">
          <p>
            No Data for selected period
          </p>
      </div>

      <div v-else-if="store.isLoading === true && store[store.dataKey].length === 0">
        <div data-dev-group="data-loading-table" >
          
          <p>
            Loading...
          </p>
          
          <!-- Spacing -->
          <br /><br /><br /><br /><br /><br /><br />
          <!-- end of Spacing -->
          
          <div class="q-pa-md">
            <q-markup-table>
              <thead>
                <tr>
                  <th v-for="(column, index) in [{ class: 'text-left', width: '150px' },{ class: 'text-right' },{ class: 'text-right' },{ class: 'text-right' },{ class: 'text-right' },{ class: 'text-right' }]"
                    :key="index" :class="column.class" :style="{ width: column.width || 'auto' }">
                    <q-skeleton animation="blink" type="text" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="n in 5" :key="n">
                  <td v-for="(width, index) in ['85px', '50px', '35px', '65px', '25px', '85px']" :key="index" :class="index === 0 ? 'text-left' : 'text-right'">
                    <q-skeleton animation="blink" type="text" :width="width" />
                  </td>
                </tr>
              </tbody>
            </q-markup-table>
          </div>
        </div>

      </div>
        
      <div v-else-if="store.error === true">
        <p>
          Server Error
        </p>
      </div>
        
      <div v-else data-dev-group="data" >
        
        <div data-dev-group="data-meta" >
          <!-- Buttons -->
          <button @click="store.getData()" :disabled="store.isLoading">Refresh</button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          
          <span v-if="store.isLoading === true">Refreshing...</span>
          <span v-else >&nbsp;</span>
          <!-- End of Buttons -->
        </div>

        <div data-dev-group="data" >
          
          
          
          <!-- DEBUG DEV -->
          <!-- <div>
            {{ store.dataArray }}
          </div> -->
          <!-- End of DEBUG DEV -->


          <!-- Company Select Filter-->
          <div>
            <select v-model="selectedCompany">
              <option value="All">All</option>
              <option v-for="key in Object.keys(companyNames)" :key="key" :value="companyNames[key]">{{ companyNames[key] }}</option>
            </select>
            <h6 v-if="selectedCompany !== 'All'">Filtered by {{ selectedCompany }}</h6>
          </div>
          <!-- End of Company Select Filter-->

          <!-- Charges Table -->
          <div class="charges-data">
            <BasicTableComponent 
              tableClass="chargesTable"
              :list="filteredArray"
              :hideColumns="['data_array']"
              :totals="tableTotals"
            />
              
          </div>
          <!-- End of Charges Data -->

          <!-- <h6>Selected Timeperiod Week</h6> -->
            



          


        </div>
      </div>

      <!-- To Be Removed -->
      <div data-dev-group="DEBUG-data">
        <!-- <div>
          <h6>Raw Data - Top Sales Day</h6>
          {{store.topSalesDay}}
        </div> -->

        <!-- <div>
          <h6>Raw Data - Top Sales Week</h6>
          {{store.topSalesWeek}}
        </div> -->
      </div>

    </div>
    
    <!-- </q-pull-to-refresh> -->
  </div>
</template>

<script>
export default {
  name:'ChargesTable',
  inject:['page'],
  // props:['storeName'],
  props:{
    storeName:{type:String},
    selectedTimePeriod:{default:'day'},
  },
  data(){
    return {
      // tmp home
      selectedCompany: 'All',
      // end of tmp home

      meta:{
        dow:false,
        // showDetails: false,
      },
    }
  },
  mounted(){
  },
  computed:{
    store(){return this.page.$refs[this.storeName ? this.storeName : 'monthlyChargesStore']},
    departments(){return this.store.deptKeys},
    filteredArray(){
      return this.selectedCompany !== 'All' ? this.store.dataArray.filter(r=> r.account === this.selectedCompany) : this.store.dataArray
    },
    // selectedTransactions(){return this.$util.sortAscForKeyPath(this.store.selectedTransactions, 'DateTime', false)},
    // keys(){return Object.keys(this.store[`${this.selectedTimePeriod}Transactions`]).sort().reverse()},
    // timestamps(){ return this.store.timestamps},
    // dateKey(){ return this.timestamps.dateKey},
    companyNames(){return this.$chargeAccountCompanyNames},
    tableTotals(){
      const sum = this.$math.sumKeys(this.filteredArray)
      return [{DateTime:"Total", Invoice_Number:`Count: ${this.filteredArray.length}`,Grand_Total:sum.Grand_Total}]
    },
  },
  methods:{

  }
}
</script>

<style>

.chargesTable {
  width: 300px;
}
.chargesTable td {
  white-space: nowrap;
  max-width: 250px;
  min-width: 10px;
  overflow: visible;
  padding-left:10px;
}

.chargesTable th:nth-child(3n+3){
  padding-right: 20px;
}

.chargesTable td:nth-child(3n+3){
  padding-right: 20px;
}
</style>